import { customAlphabet } from "nanoid";

const alphabet = "0123456789abcdef";
const nanoid32 = customAlphabet(alphabet, 32);

export const generateCorrelationId = (): string => nanoid32();
